import _ from "lodash";
import { Form } from "react-final-form";
import React, { useState } from "react";
import { snakifyKeys } from "../../../util/helpers";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { TestRepositoryForm } from "./TestRepositoryForm";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";

export const EditTestRepositoryModal = ({ testRepository, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleUpdate = async (values) => {
    const test = snakifyKeys(values);

    setError(null);

    try {
      const res = await api.patch(`/admin/tests/${testRepository.id}`, { test });

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Edit Product/Procedure/Test</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={{ ...testRepository }}>
            {(props) => <TestRepositoryForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
